import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdvertisementComponent } from './advertisement/advertisement.component';

@NgModule({
  declarations: [AdvertisementComponent],
  imports: [
    CommonModule
  ],
  exports:[AdvertisementComponent]
})
export class AdvertisementModule { }
